import { render, staticRenderFns } from "./SummaryElement.vue?vue&type=template&id=62f6a0fa&scoped=true"
import script from "./SummaryElement.vue?vue&type=script&lang=js"
export * from "./SummaryElement.vue?vue&type=script&lang=js"
import style0 from "./SummaryElement.vue?vue&type=style&index=0&id=62f6a0fa&prod&lang=scss"
import style1 from "./SummaryElement.vue?vue&type=style&index=1&id=62f6a0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f6a0fa",
  null
  
)

export default component.exports